import { useLoadAuthUser } from '../../../hooks/authhooks';
import LoadingScreen from "../../shared/LoadingScreen";
import { useAuthState } from '../../../contexts/authcontext'
import SelfServiceAdmin from './SelfServiceAdmin';
import LoggedOutSelfServiceRegistration from './LoggedOutSelfServiceRegistration';

// Sample companies data - in a real app, this would come from an API
export const COMPANIES = [
  { id: '1', name: 'Amerigroup', boothNumber: 'A1' },
  { id: '2', name: 'BCFSN', boothNumber: 'A2' },
  { id: '3', name: 'CM Felder', boothNumber: 'A3' },
  { id: '4', name: 'DC Gov\'t', boothNumber: 'A4' },
  { id: '5', name: 'DPR Environmental Division', boothNumber: 'A5' },
  { id: '6', name: 'Children\'s National', boothNumber: 'B1' },
  { id: '7', name: 'East River Collaborative', boothNumber: 'B2' },
  { id: '8', name: 'Earth Conservation Corp', boothNumber: 'B3' },
  { id: '9', name: 'DC Central Kitchen', boothNumber: 'B4' },
  { id: '10', name: 'The Links', boothNumber: 'B5' },
  { id: '11', name: 'Common Good City Farms', boothNumber: 'C1' },
  { id: '12', name: 'EOM / DC Food Policy / Office of Planning', boothNumber: 'C2' },
  { id: '13', name: 'DC Legal Aid', boothNumber: 'C3' },
  { id: '14', name: 'HomeCook', boothNumber: 'C4' },
  { id: '15', name: 'SWAP DC', boothNumber: 'C5' }
];
// const SIGN_IN_METHODS = [
//   { id: 'email', label: 'Email' },
//   { id: 'phone', label: 'Phone Number' }
// ];

// interface EventDetails {
//   name: string;
//   logo?: string;
//   organizer: string;
//   organizerUrl: string;
//   date: string;
//   startTime: string;
//   endTime: string;
// }

// interface EventDetailsMap {
//   [key: string]: EventDetails;
// }

// // Event details mapping
// const EVENT_DETAILS: EventDetailsMap = {
//   'springfest': {
//     name: 'SpringFest 2025',
//     logo: 'https://dreamingoutloud.org/wp-content/uploads/2024/10/Dreaming-Out-Loud-Home-Logo-.webp',
//     organizer: 'Dreaming Out Loud',
//     organizerUrl: 'https://dreamingoutloud.org',
//     date: 'April 15, 2025',
//     startTime: '10:00 AM',
//     endTime: '6:00 PM'
//   },
//   'summerfest': {
//     name: 'SummerFest 2025',
//     logo: 'https://dccentralkitchen.org/wp-content/uploads/2022/03/DCCentralKitchen_logo-hi-res-75x75.png',
//     organizer: 'DC Central Kitchen',
//     organizerUrl: 'https://dccentralkitchen.org/',
//     date: 'July 20, 2025',
//     startTime: '9:00 AM',
//     endTime: '5:00 PM'
//   },
//   // Add more events as needed
// };


const SelfServiceRegistration = () => {
  const { isloggedin } = useAuthState()
  const { isLoading } = useLoadAuthUser();

  if (isLoading) {
    return <LoadingScreen />;
  }
  return isloggedin ? ( <SelfServiceAdmin isloggedin={isloggedin} /> ) : ( <LoggedOutSelfServiceRegistration /> )
};



export default SelfServiceRegistration; 